function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.66869 1.03185C6.35919 2.67857 5.19474 5.6424 5.97206 8.54339C6.74938 11.4444 9.23973 13.4289 12.0632 13.7003C11.4005 14.1727 10.6436 14.5368 9.81128 14.7598C6.07795 15.7601 2.24054 13.5446 1.2402 9.81128C0.239852 6.07795 2.45538 2.24054 6.18872 1.2402C7.02107 1.01717 7.85859 0.953993 8.66869 1.03185ZM9.92631 2.70573L10.3977 4.15643H11.923L10.689 5.05301L11.1604 6.50372L9.92631 5.60713L8.69227 6.50372L9.16363 5.05301L7.92959 4.15643H9.45495L9.92631 2.70573ZM13.197 9.05521L12.7256 7.60451L12.2543 9.05521H10.7289L11.9629 9.9518L11.4916 11.4025L12.7256 10.5059L13.9597 11.4025L13.4883 9.9518L14.7223 9.05521H13.197Z",
  fill: "#9492C4"
});

var SvgMoon = function SvgMoon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMoon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/moon.09c41919.svg";
export { ForwardRef as ReactComponent };